import { SvgIconType } from './svg.interface';

const Expedite: SvgIconType = ({
  width = 12,
  height = 8,
  className = '',
  color = '#3AA5DC',
  onClick
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      d="M1.21553 7.53771C0.723851 7.92695 0 7.57677 0 6.94967V1.05033C0 0.423225 0.723851 0.0730488 1.21553 0.462292L4.94143 3.41197C5.32073 3.71224 5.32073 4.28776 4.94143 4.58803L1.21553 7.53771ZM7.53132 7.53771C7.03964 7.92695 6.31579 7.57677 6.31579 6.94967V1.05033C6.31579 0.423226 7.03964 0.0730489 7.53132 0.462292L11.2572 3.41197C11.6365 3.71224 11.6365 4.28776 11.2572 4.58803L7.53132 7.53771Z"
      fill={color}
    />
  </svg>
);

export default Expedite;
